import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    separator: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: '10px'
    },
    item: {
        height: '0.7em',
        flexGrow: '1',
        backgroundColor: 'purple'
    },
    green70:{
        backgroundColor: '#658D1B'
    },
    green60:{
        backgroundColor: '#7C9E3D'
    },
    green40:{
        backgroundColor: '#AAC082'
    },
    green30:{
        backgroundColor: '#C1D1A4'
    },
    green10:{
        backgroundColor: '#F0F4E8'
    }
}));

export default useStyles;
